module.exports = __webpack_public_path__ + "static/img/banner_solutions_ime.63c1250.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_ime.png
// module id = P1ZA
// module chunks = 10